var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex items-start mb-4 p-4 bg-white rounded border border-solid",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex flex-col items-start justify-center gap-3 flex-1 grow font-outfit",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex items-start justify-between self-stretch w-full",
            },
            [
              _c(
                "div",
                { staticClass: "flex items-start gap-2 flex-1 grow" },
                [
                  _c("ResourceAvatar", {
                    staticClass: "cursor-pointer text-primary-600",
                    attrs: {
                      image: _vm.note.contractor?.user?.avatar,
                      initial: _vm.contractorInitials,
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass:
                        "inline-flex flex-col items-start justify-center gap-2 self-stretch",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col items-start gap-1 self-stretch w-full",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-semibold text-xl text-primary-black",
                            },
                            [_vm._v(" " + _vm._s(_vm.contractorFullName) + " ")]
                          ),
                          _c("div", { staticClass: "text-sm text-dark-gray" }, [
                            _vm._v(" " + _vm._s(_vm.jobTitle) + " "),
                          ]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-center gap-2 self-stretch w-full",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "inline-flex items-center gap-1 self-stretch",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "font-medium text-dark-gray text-sm hidden sm:block",
                                },
                                [_vm._v(" Visit date: ")]
                              ),
                              _c(
                                "div",
                                { staticClass: "text-dark-gray text-sm" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formattedDate(_vm.note.created_at)
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "inline-flex items-center gap-1 self-stretch",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "font-medium text-dark-gray text-sm hidden sm:block",
                                },
                                [_vm._v(" Note recorded: ")]
                              ),
                              _c(
                                "div",
                                { staticClass: "text-dark-gray text-sm" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.formattedTime(_vm.note.created_at)
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "flex w-6 items-start gap-2.5 pb-0 px-0 self-stretch",
                },
                [_c("CommentChatWrapper")],
                1
              ),
            ]
          ),
          _c(
            "p",
            { staticClass: "self-stretch font-outfit font-light text-sm" },
            [_vm._v(" " + _vm._s(_vm.note.note) + " ")]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }